import { render, staticRenderFns } from "./FudaoStudentEndSessionDialog.vue?vue&type=template&id=70f3a6e8&scoped=true&"
import script from "./FudaoStudentEndSessionDialog.vue?vue&type=script&lang=js&"
export * from "./FudaoStudentEndSessionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f3a6e8",
  null
  
)

export default component.exports